export const bikeAllKey = 'bikeAll';
export const bikeAllListKey = 'bikeAllList';
export const bikeNoAccountKey = 'bikeNoAccount';
export const bikeNoAccountListKey = 'bikeNoAccountList';
export const getBikeKey = 'getBike';
export const getBikeListKey = 'getBikeList';
export const deleteBikeKey = 'deleteBike';
export const editBikeKey = 'editBike';
export const editBikeProKey = 'editBikePro';
export const updateBikeKey = 'updateBike';
export const addBikeKey = 'addBike';
export const addBikeProKey = 'addBikePro';
export const clearBikeKey = 'clearBike';

export const carAllKey = 'carAll';
export const carAllListKey = 'carAllList';
export const carNoAccountKey = 'carNoAccount';
export const carNoAccountListKey = 'carNoAccountList';
export const getCarKey = 'getCar';
export const getCarListKey = 'getCarList';
export const deleteCarKey = 'deleteCar';
export const editCarKey = 'editCar';
export const editCarProKey = 'editCarPro';
export const updateCarKey = 'updateCar';
export const addCarKey = 'addCar';
export const addCarProKey = 'addCarPro';
export const clearCarKey = 'clearCar';

export const commercialAllKey = 'commercialAll';
export const commercialAllListKey = 'commercialAllList';
export const commercialNoAccountKey = 'commercialNoAccount';
export const commercialNoAccountListKey = 'commercialNoAccountList';
export const getCommercialKey = 'getCommercial';
export const getCommercialListKey = 'getCommercialList';
export const deleteCommercialKey = 'deleteCommercial';
export const editCommercialKey = 'editCommercial';
export const editCommercialProKey = 'editCommercialPro';
export const updateCommercialKey = 'updateCommercial';
export const addCommercialKey = 'addCommercial';
export const addCommercialProKey = 'addCommercialPro';
export const clearCommercialKey = 'clearCommercial';

export const archiveListKey = 'archiveList';
export const basePoliceListKey = 'basePoliceList';
export const dealerListKey = 'dealerList';
